export default __webpack_public_path__ + "static/media/book-4.6adad8f1.jpeg";